import React from "react";
import {useLanguageForShared} from "../../../../../../../shared/utils/languages/useLanguageForShared";
import {PrescriptionTemplate} from "./PrescriptionTemplate";
import {TemplateBase} from "./TemplateBase";


export function TemplateCOX_POC({
                                    dataForm,
                                    changeValue,
                                    errors,
                                    setData,
                                    isSubmit,
                                }) {
    const {t} = useLanguageForShared()


    return (
        <>
            <TemplateBase
                dataForm={dataForm}
                changeValue={changeValue}
                errors={errors}
                isSubmit={isSubmit}
                setData={setData}
            >
                <PrescriptionTemplate
                    dataForm={dataForm}
                    changeValue={changeValue}
                    errors={errors}
                    isSubmit={isSubmit}
                    setData={setData}
                    paramsPrescription={{title: t('prescription.template.prescriptionCOX')}}
                    type={'COX'}
                />
                <PrescriptionTemplate
                    dataForm={dataForm}
                    changeValue={changeValue}
                    errors={errors}
                    isSubmit={isSubmit}
                    setData={setData}
                    paramsPrescription={{hasLevelData:true, hasTypeflow: true, title: t('prescription.template.prescriptionPOC')}}
                    type={'POC'}
                />
            </TemplateBase>
        </>
    );
}
